// src/models/administrativo/ConfigModulo.js
const ModuloEnum = Object.freeze({
  Bar: 1,
  Mercado: 2,
});

const DFePadraoEnum = Object.freeze({
  NFCe: 1,
  NFe: 2,
});

const normalizarDFePadrao = (valor) => (
  Number(valor) === DFePadraoEnum.NFe
    ? DFePadraoEnum.NFe
    : DFePadraoEnum.NFCe
);

const permiteEmissaoNotaProduto = (configModulo) => (
  Number(configModulo?.emiteNFCe) === 1 || Number(configModulo?.emiteNFe) === 1
);

class ConfigModulo {
  constructor(
    id = 0,
    filialId = 0,
    nomeEstabelecimento = null,
    modulo = ModuloEnum.Bar,
    controleEstoque = null,
    emiteNFCe = null,
    emiteNFe = null,
    emiteMDFe = false,
    tipoPix = null,
    chavePix = null,
    nomeRecebedor = null,
    cidadeRecebedor = null,
    moduloPedido = null,
    controleMesa = null,
    corApp = null,
    corFonteApp = null,
    printValUnRec = null,
    printCelular = null,
    perguntaImpressao = null,
    imprimePrevisao = null,
    imprimeHorario = null,
    imprimirPedidoAvulso = null,
    eventoTicketDesc = null,
    pedidoGeraNota = null,
    printPedidoAceito = null,
    exibirConcluido = null,
    monitorDesktop = null,
    monitorWeb = null,
    exibirOrigemPedido = null,
    usaIdDia = null,
    mensalidade = null,
    criaClienteWhats = null,
    androidMonitorTef = null,
    androidEmiteDFE = null,
    androidFechaComanda = null,
    testeTEF = false,
    androidAtualizaDados = null,
    usaOS = null,
    androidMesa = false,
    androidComanda = false,
    dFePadrao = DFePadraoEnum.NFCe,
    comprovantePagComanda = false,
    taxaEntregaBairro = false,
    usaFinanceiro = false,
    usaPrioridadeOS = false
  ) {
    this.id = id;
    this.filialId = filialId;
    this.nomeEstabelecimento = nomeEstabelecimento;
    this.modulo = modulo;
    this.controleEstoque = controleEstoque;
    this.emiteNFCe = emiteNFCe;
    this.emiteNFe = emiteNFe;
    this.emiteMDFe = emiteMDFe;
    this.tipoPix = tipoPix;
    this.chavePix = chavePix;
    this.nomeRecebedor = nomeRecebedor;
    this.cidadeRecebedor = cidadeRecebedor;
    this.moduloPedido = moduloPedido;
    this.controleMesa = controleMesa;
    this.corApp = corApp;
    this.corFonteApp = corFonteApp;
    this.printValUnRec = printValUnRec;
    this.printCelular = printCelular;
    this.perguntaImpressao = perguntaImpressao;
    this.imprimePrevisao = imprimePrevisao;
    this.imprimeHorario = imprimeHorario;
    this.imprimirPedidoAvulso = imprimirPedidoAvulso;
    this.comprovantePagComanda = comprovantePagComanda === true;
    this.eventoTicketDesc = eventoTicketDesc;
    this.pedidoGeraNota = pedidoGeraNota;
    this.printPedidoAceito = printPedidoAceito;
    this.exibirConcluido = exibirConcluido;
    this.monitorDesktop = monitorDesktop;
    this.monitorWeb = monitorWeb;
    this.exibirOrigemPedido = exibirOrigemPedido;
    this.usaIdDia = usaIdDia;
    this.mensalidade = mensalidade;
    this.criaClienteWhats = criaClienteWhats;
    this.androidMonitorTef = androidMonitorTef;
    this.androidEmiteDFE = androidEmiteDFE;
    this.androidFechaComanda = androidFechaComanda;
    this.testeTEF = testeTEF;
    this.androidAtualizaDados = androidAtualizaDados;
    this.usaOS = usaOS;
    this.usaPrioridadeOS = usaPrioridadeOS === true;
    this.androidMesa = androidMesa;
    this.androidComanda = androidComanda;
    this.dFePadrao = normalizarDFePadrao(dFePadrao);
    this.taxaEntregaBairro = taxaEntregaBairro === true;
    this.usaFinanceiro = usaFinanceiro === true;
  }
}

export { ConfigModulo, ModuloEnum, DFePadraoEnum, normalizarDFePadrao, permiteEmissaoNotaProduto };
